<template>
  <div>
    <el-card class="box-card brand-place-of-origin-container" ref="card">
      <div slot="header" class="clearfix" style="display: flex;align-items: center;justify-content: space-between;">
        <div>
          <b style="margin-right: 20px;">产地维度</b>
          <el-date-picker
              v-model="date_s" value-format="yyyy-MM"
              type="month" size="mini" style="width: 110px;" :clearable="false"/>
          对比
          <el-date-picker
              v-model="date_e" value-format="yyyy-MM"
              type="month" size="mini" style="width: 110px;" :clearable="false"/>
        </div>
        <div>
          <el-button size="mini" type="primary" plain icon="el-icon-upload2"
                     @click="$refs.feishuSyncDialog.open('place_of_origin')" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
          <el-link :underline="false" type="info" @click="handelEx">
            <i class="el-icon-download" style="font-size: 1.5rem;color: rgb(255, 90, 145);"/>
          </el-link>
          <el-link style="padding: 3px 0;margin-left: 10px" type="primary" :underline="false"
                   title="点击刷新" @click="getData">
            <i class="el-icon-refresh-right"/>
          </el-link>
        </div>
      </div>
      <el-table class="dashboard-table"
                id="brand-place-of-origin"
                show-summary
                :summary-method="getSummaries"
                :data="data"
                :row-style="{ border: 'none',padding:'15px 0'}"
                :cell-style="{ border: 'none'}"
                style="width: 100%" v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading">
        <el-table-column prop="place_of_origin" label="产地" align="center" />
        <el-table-column prop="customer_after" label="客户数" align="center" />
        <el-table-column prop="trade_after" label="行业数" align="center" />
        <el-table-column prop="order_after" label="订单数" align="center" />
        <el-table-column prop="money_before" align="center" :label="`${date_s_label}投放金额/万`">
          <template v-slot="{row:{money_before}}">
            <span class="money">{{ money_before|numberFormatW }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="money_after" align="center" :label="`${date_e_label}投放金额/万`">
          <template v-slot="{row:{money_after}}">
            <span class="money">{{ money_after|numberFormatW }}</span>
          </template>
        </el-table-column>
        <el-table-column label="投放同比" align="center">
          <template v-slot="{row:{percent}}">
            <span>{{ percent !== null ? percent + ' %' : '/' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <feishu-sync-dialog ref="feishuSyncDialog" :scopes="syncScopes" :condition="condition"
                        :params="syncFeishuParams"/>
  </div>
</template>
<script>
import { getDashboardBrandPlaceOfOrigin } from "@/api/dashboard";
import {
  feishuPlaceOfOriginSyncConfig,
  saveFeishuPlaceOfOriginSyncConfig,
  feishuSyncPlaceOfOrigin
} from "@/api/feishu";
import FeishuSyncDialog from "@/components/summary/FeishuSyncDialog.vue";
import moment from "moment";
import {exportToExcel} from "@/utils/export/el-table-export";

// 「同步到飞书」维度配置（共用 FeishuSyncDialog）
const SYNC_SCOPES = {
  place_of_origin: {
    label: '产地维度',
    entity: '产地',
    rowHint: '每个产地写入一条记录',
    getConfig: feishuPlaceOfOriginSyncConfig,
    saveConfig: saveFeishuPlaceOfOriginSyncConfig,
    sync: feishuSyncPlaceOfOrigin
  }
}

export default {
  name: "SummaryBrandPlaceOfOrigin",
  components: {FeishuSyncDialog},
  inject: ['condition'],
  data() {
    return {
      // 同步到飞书：维度配置（共用 FeishuSyncDialog）
      syncScopes: SYNC_SCOPES,
      loading: false,
      queryOrder: '',
      queryProp: '',
      data: [],
      brandRealCount: 0,
      date_s: null,
      date_e: null,
      gridData: [],
      drawer: false,
      drawerTitle: '产地',
      direction: 'rtl',
    }
  },
  computed: {
    date_s_label() {
      const date_s = this.date_s.split('-')
      return `${date_s[0]}年${date_s[1]}月`
    },
    date_e_label() {
      const date_e = this.date_e.split('-')
      return `${date_e[0]}年${date_e[1]}月`
    },
  },
  created() {
    this.getData()
  },
  watch: {
    condition: {
      handler: function () {
        this.date_e = `${this.condition.year}-${this.condition.month}`
        this.date_s = moment(this.date_e, "YYYY-MM").subtract(1, 'months').format('YYYY-MM')
        this.getData()
      },
      deep: true
    },
    date_s() {
      this.getData()
    },
    date_e() {
      this.getData()
    }
  },
  methods: {
    handelEx: function () {
      exportToExcel('#brand-place-of-origin', '产地统计')
      this.$message.success('导出成功')
    },
    setDate: function () {
      this.date_e = this.date_e || `${this.condition.year}-${this.condition.month}`
      this.date_s = this.date_s || moment(this.date_e, "YYYY-MM").subtract(1, 'months').format('YYYY-MM')
    },
    // 「同步到飞书」维度参数（产地维度按对比期 before/after 取数）
    syncFeishuParams() {
      let s = this.date_s
      let e = this.date_e
      if (new Date(e).getTime() < new Date(s).getTime()) {
        const tmp = s
        s = e
        e = tmp
      }
      const build = (val) => {
        const parts = (val || '').split('-')
        return {year: parts[0], month: parts[1]}
      }
      return {
        before: build(s),
        after: build(e),
        organization_id: this.condition.organization_id || ''
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let params = {...{}, ...this.condition}
      params = {...params}
      if (new Date(this.date_e).getTime() < new Date(this.date_s).getTime()) {
        const date_e_old = this.date_e
        const date_s_old = this.date_s
        this.date_s = date_e_old
        this.date_e = date_s_old
      }

      const date_e = this.date_e.split('-')
      const date_s = this.date_s.split('-')

      params.after = {year: date_e[0], month: date_e[1]}
      params.before = {year: date_s[0], month: date_s[1]}
      return params
    },
    getData() {
      this.setDate()
      this.loading = true;
      this.data = [];
      const searchCondition = this.handleSearchCondition()
      getDashboardBrandPlaceOfOrigin(searchCondition).then(res => {
        this.loading = false;
        this.data = res.model || [];
      })
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        if (['money_before', 'money_after'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "money_before":
            case "money_after":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index]);
              break;
          }
        }
      });
      return sums
    }
  }
}

</script>
<style lang="scss">
.brand-place-of-origin-container {
  .el-input--mini .el-input__inner {
    height: 20px !important;
    line-height: 20px !important;
  }

  .el-input--mini .el-input__icon {
    line-height: 20px !important;
  }
}
</style>
